import React from "react";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { PrivateRoutes } from "./allRoutes";
import { isAuthenticated } from "../services/auth";
import { hasAnyPermission } from "../utils/adminPermissions";
import { useSelector } from "react-redux";

const Auth = () => {
    return isAuthenticated() ? <Outlet /> : <Navigate to="/" replace />;
};

const firstAllowedRoute = (profile) => {
    const route = PrivateRoutes.find(
        (item) => item.path !== "/profile" && item.path !== "/403" && hasAnyPermission(profile, item.permissions || (item.permission ? [item.permission] : []))
    );
    return route?.path || "/profile";
};

const PermissionRoute = ({ route }) => {
    const location = useLocation();
    const { userProfile, loaded } = useSelector((state) => state.profile);
    const permissions = route.permissions || (route.permission ? [route.permission] : []);

    if (!loaded) return null;
    if (hasAnyPermission(userProfile, permissions)) return route.element;

    return (
        <Navigate
            to={location.pathname === "/dashboard" ? firstAllowedRoute(userProfile) : "/403"}
            replace
        />
    );
};

export const ProtectedRoutes = () => {
    return (
        <Routes>
            <Route element={<Auth />}>
                {PrivateRoutes.map((route, key) => (
                    <Route key={key} path={route.path} element={<PermissionRoute route={route} />} />
                ))}
            </Route>
        </Routes>
    );
};
